
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15.469 4.996c-1.157-1.157-3.081-1.536-4.588-.028l-6.27 6.27a.806.806 0 01-1.14-1.14l6.27-6.27c2.277-2.277 5.231-1.608 6.867.028.824.823 1.388 1.95 1.455 3.176.068 1.245-.381 2.534-1.483 3.635l-6.84 6.84a3.878 3.878 0 01-1.743.987c-.79.192-1.738.091-2.531-.702-.833-.833-.953-1.778-.719-2.59.215-.743.707-1.331 1.032-1.656l5.272-5.272.57.57.57.57-5.272 5.271c-.245.245-.518.601-.623.964-.085.294-.076.617.31 1.003.32.32.654.362 1.01.275.4-.097.78-.355.985-.56l6.84-6.84c.79-.79 1.054-1.639 1.012-2.407-.043-.788-.411-1.55-.984-2.124zM12.19 8.273a.806.806 0 010 1.14l-.57-.57-.57-.57a.806.806 0 011.14 0z","fill":"#C5CBD5"}})])
          )
        }
      }
    